export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12850.96c144d6.jpg";